import { render } from "./BarreNavigation.vue?vue&type=template&id=a2655294&scoped=true"
import script from "./BarreNavigation.vue?vue&type=script&lang=js"
export * from "./BarreNavigation.vue?vue&type=script&lang=js"

import "./BarreNavigation.vue?vue&type=style&index=0&id=a2655294&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2655294"]])

export default __exports__